import { createFileRoute, redirect } from "@tanstack/react-router";
import { getWikiRedirect } from "@/features/community/records";
import {
  CommunityPageLoading,
  CommunityPageError,
} from "@/features/community/navigation";

export const Route = createFileRoute("/_site/wiki/")({
  beforeLoad: async ({ location, abortController }) => {
    const href = await getWikiRedirect({
      data: { href: location.href },
      signal: abortController.signal,
    });
    throw redirect({ href, statusCode: 307 });
  },
  pendingComponent: () => <CommunityPageLoading title="Wiki" />,
  errorComponent: ({ error, reset }) => (
    <CommunityPageError error={error} retry={reset} />
  ),
});
